<template>
  <div v-if="compliance" id="complienceForm">

    <div class="form-group text-center">
      <p class="compliance-text-header">
        {{
          element.answer[0].type == "agreement"
            ? `${element.name}`
            : `${element.name}`
        }}
      </p>

      <span v-if="compliance.haveWrongAnswers === null && element.answer[0].type == 'agreement'" class="info vp-mb-40">{{ $tc("signInOut.complianceHeader", 1) }}</span>
      <span v-if="compliance.haveWrongAnswers === null && element.answer[0].type == 'questionnaire'" class="info vp-mb-40">{{ $tc("signInOut.questionnaireHeader", 1) }}</span>

      <span v-if="compliance.haveWrongAnswers === true" class="info-success-fail-text vp-mb-30">{{ $tc("signInOut.complianceFailed") }}</span>
      <span v-if="compliance.haveWrongAnswers === false" class="info-success-fail-text vp-mb-30">{{ $tc("signInOut.complianceCompleted", 1) }}</span>

    </div>

    <div class="user-infocontainer">
      <p class="user-info" v-if="element.pivot && element.pivot.updated_at">
        {{ getDate(element.pivot.updated_at) }}<b>  &ensp;<b> • </b>&ensp; </b> {{ $t("common.by") }}
        {{
          element.pivot && element.pivot.metadata
            ? getAdminOrUserStr(element.pivot.metadata[0].actionBy)
            : element.pivot.notes
            ? JSON.parse(element.pivot.notes).actionBy
            : "User"
        }}<strong class="user-strong-txt">
          ({{
            element.pivot.full_name_action_by
              ? element.pivot.full_name_action_by
              : element.pivot.notes
              ? JSON.parse(element.pivot.notes).fullName
              : "-"
          }})</strong
        >
      </p>
    </div>

    <div
      class="form-group question-wrapper facemask-questioncon"
      v-for="(question, i) in compliance.answer"
      :key="i"
    >
      <!-- Question -->

      <template v-if="question.content_type == 'IMAGE'">
        <div class="img-agr vp-mb-32">
          <img v-viewer :src="question.attachment_url" class="cursor-zoomin thumbnail-image" />
        </div>
      </template>

      <template v-else-if="question.content_type == 'PDF'">
        <div class="pdf-agr vp-mb-32">
        <div class="pdf-con">
          <div class="d-flex align-items-center justify-content-between" style="padding: 20px 20px 0 24px;">
            <div style="max-width: 96%;">
              <span class="cursor-pointer" @click="openPDF(question.attachment_url)">{{ getPDFName(question.attachment_url) }}</span>
            </div>
            <svg class="cursor-pointer" @click="openPDF(question.attachment_url)" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M14.0864 0C14.5903 4.31018e-08 14.9987 0.415294 14.9987 0.927585L14.9987 4.86299C14.9987 5.37528 14.5903 5.79058 14.0864 5.79058C13.5826 5.79058 13.1741 5.37528 13.1741 4.86299V3.16697L9.89333 6.50274C9.53706 6.86499 8.95942 6.86499 8.60314 6.50274C8.24687 6.1405 8.24687 5.55319 8.60314 5.19094L11.884 1.85517L10.2159 1.85517C9.71203 1.85517 9.30358 1.43988 9.30358 0.927584C9.30358 0.415294 9.71203 4.91633e-08 10.2159 6.22367e-09L14.0864 0Z" fill="#103F5E"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0 3.77216C0 2.08096 1.3484 0.709961 3.01174 0.709961H6.52544C7.07989 0.709961 7.52936 1.16696 7.52936 1.73069C7.52936 2.29443 7.07989 2.75143 6.52544 2.75143H3.01174C2.4573 2.75143 2.00783 3.20843 2.00783 3.77216V11.938C2.00783 12.5018 2.4573 12.9588 3.01174 12.9588H11.0431C11.5975 12.9588 12.047 12.5018 12.047 11.938V8.36546C12.047 7.80173 12.4964 7.34473 13.0509 7.34473C13.6053 7.34473 14.0548 7.80173 14.0548 8.36546V11.938C14.0548 13.6292 12.7064 15.0002 11.0431 15.0002H3.01174C1.3484 15.0002 0 13.6292 0 11.938V3.77216Z" fill="#103F5E"/>
            </svg>
          </div>
          <hr style="border-top: 1px solid #C8C0C0; margin: 20px 0 0 0;">
          </div>
          <div class="iframe-con">
            <iframe 
            class="iframe-container"
              :src="question.attachment_url + '#toolbar=0&navpanes=0&scrollbar=0'" 
              width="100%" 
              style="border:none;">
            </iframe>
          </div>
        </div>
      </template>

      <p v-if="question.content_type == 'TEXT'" id="question-group" class="second-info ">
      
        {{ element.answer[0].type == "questionnaire" ? i + 1 + "-" : "" }}
        <template v-if="!readMore[question.body]">
          {{ question.body.substring(0, 150) }}
        </template>

        <template v-if="readMore[question.body]">
          {{ question.body }}
        </template>

        <a
          class="read_more"
          v-if="!readMore[question.body] && question.body.length >= 200"
          @click="showMore(question.body)"
          >{{ $t('common.readMore') }}</a
        >
        <a
          class="read_more"
          v-if="readMore[question.body]"
          @click="showLess(question.body)"
          >{{ $t('common.readLess') }}</a
        >
      </p>

      <!-- <v-radio-group v-model="question.pivot.answer.text" @change="updatePivot(question, question.pivot.answer.text, i)">
        <v-radio :label="question.answers[0].text" :value="question.answers[0].text"/>
        <v-radio  :label="question.answers[1].text" :value="question.answers[1].text"/>
      </v-radio-group> -->
      <!-- <hr class="questions-divider" /> -->
      <div class="radios-container">
      <v-radio-group
        v-model="question.pivot.answer.text"
        stacked
        @change="updatePivot(question, question.pivot.answer.text, i)"
      >
        <v-radio 
        :value="question.answers[0]?.text"
        :label="question.answers[0].text"
        :color="question.pivot.userInteracted
        ? (question.answers[0].desired && question.pivot.answer && question.answers[0].text == question.pivot.answer.text ? '#34C38F' :
           !question.answers[0].desired && question.pivot.answer && question.answers[0].text == question.pivot.answer.text ? '#F46A6A' : '')
        : (element.pivot && element.pivot?.metadata && element.pivot?.metadata[0]?.actionBy == 'Admin' && !question.answers[0].desired ? '#103f5e' :
           question.answers[0].desired && question.pivot.answer && question.answers[0].text == question.pivot.answer.text ? '#34C38F' :
           !question.answers[0].desired && question.pivot.answer && question.answers[0].text == question.pivot.answer.text ? '#F46A6A' : '')"
                    
        :class="
          question.pivot.userInteracted
            ? (question.answers[0].desired && question.pivot.answer && question.answers[0].text == question.pivot.answer.text ? 'text-success' :
               !question.answers[0].desired && question.pivot.answer && question.answers[0].text == question.pivot.answer.text ? 'text-danger' : '')
            : (element.pivot && element.pivot?.metadata && element.pivot?.metadata[0]?.actionBy == 'Admin' && !question.answers[0].desired ? '' :
               question.answers[0].desired && question.pivot.answer && question.answers[0].text == question.pivot.answer.text ? 'text-success' :
               !question.answers[0].desired && question.pivot.answer && question.answers[0].text == question.pivot.answer.text ? 'text-danger' : '')
        ">
          {{ question.answers[0].text }}
        </v-radio>

        <!-- <div v-if="element.pivot && element.pivot?.metadata && element.pivot.metadata[0] && element.pivot?.metadata[0]?.isWrong"> -->

          <span class="response-note-admin " v-if="!question.answers[0].desired && question.pivot.answer && question.answers[0].text == question.pivot.answer.text
            && (question.pivot.userInteracted
                ? false
                : (element.pivot && element.pivot?.metadata && element.pivot?.metadata[0]?.actionBy == 'Admin' && element.pivot?.metadata[0]?.isWrong))">
            {{ $t('signInOut.responseDoesNotMeetPolicyJustificationProvidedBelow') }}
          </span>

          <span class="response-note" v-else-if="!question.answers[0].desired && question.pivot.answer && question.answers[0].text == question.pivot.answer.text
            && (question.pivot.userInteracted
                ? false
                : (element.pivot && element.pivot?.metadata && element.pivot?.metadata[0]?.actionBy == 'User' && element.pivot?.metadata[0]?.isWrong))">
            {{ $t('signInOut.responseDoesNotMeetPolicyUpdateJustificationNotes') }}
          </span>

          <span class="response-note " v-else-if="question.pivot.userInteracted && !question.answers[0].desired && question.pivot.answer && question.answers[0].text == question.pivot.answer.text">
            {{ $t('signInOut.responseDoesNotMeetPolicyUpdateJustificationNotes') }}
          </span>

        <!-- </div> -->

        <!-- <div v-else>
          <span class="response-note vp-mb-24" v-if="!question.answers[0].desired && question.pivot.answer && question.answers[0].text == question.pivot.answer.text
            ">{{ $t('signInOut.responseDoesNotMeetPolicyUpdateJustificationNotes') }}

          </span>
        </div> -->

        <v-radio
        :value="question.answers[1].text"
        :label="question.answers[1].text"
        :color="
          question.pivot.userInteracted
            ? (question.answers[1].desired && question.pivot.answer && question.answers[1].text == question.pivot.answer.text ? '#34C38F' :
               !question.answers[1].desired && question.pivot.answer && question.answers[1].text == question.pivot.answer.text ? '#F46A6A' : '')
            : (element.pivot && element.pivot?.metadata && element.pivot?.metadata[0] && element.pivot?.metadata[0]?.actionBy == 'Admin' && !question.answers[1].desired ? '#103f5e' :
               question.answers[1].desired && question.pivot.answer && question.answers[1].text == question.pivot.answer.text ? '#34C38F' :
               !question.answers[1].desired && question.pivot.answer && question.answers[1].text == question.pivot.answer.text ? '#F46A6A' : '')
        "
         :class="
          question.pivot.userInteracted
            ? (question.answers[1].desired && question.pivot.answer && question.answers[1].text == question.pivot.answer.text ? 'text-success' :
               !question.answers[1].desired && question.pivot.answer && question.answers[1].text == question.pivot.answer.text ? 'text-danger' : '')
            : (element.pivot && element.pivot?.metadata && element.pivot?.metadata[0] && element.pivot?.metadata[0]?.actionBy == 'Admin' && !question.answers[1].desired ? '' :
               question.answers[1].desired && question.pivot.answer && question.answers[1].text == question.pivot.answer.text ? 'text-success' :
               !question.answers[1].desired && question.pivot.answer && question.answers[1].text == question.pivot.answer.text ? 'text-danger' : '')
        ">
          {{ question.answers[1].text }}
        </v-radio>

        <!-- <div v-if="element.pivot && element.pivot.metadata && element.pivot.metadata[0] && element.pivot?.metadata[0]?.isWrong"> -->

          <span class="response-note-admin " v-if="!question.answers[1].desired && question.pivot.answer && question.answers[1].text == question.pivot.answer.text
            && (question.pivot.userInteracted
                ? false
                : (!Array.isArray(element.pivot) && element.pivot && element.pivot?.metadata && element.pivot?.metadata[0]?.actionBy == 'Admin' && element.pivot?.metadata[0]?.isWrong))">
            {{ $t('signInOut.responseDoesNotMeetPolicyJustificationProvidedBelow') }}
          </span>

          <span class="response-note" v-else-if="!question.answers[1].desired && question.pivot.answer && question.answers[1].text == question.pivot.answer.text
            && (question.pivot.userInteracted
                ? false
                : (!Array.isArray(element.pivot) && element.pivot && element.pivot?.metadata && element.pivot?.metadata[0]?.actionBy == 'User' && element.pivot?.metadata[0]?.isWrong))">
            {{ $t('signInOut.responseDoesNotMeetPolicyUpdateJustificationNotes') }}
          </span>
        <!-- </div> -->


        <span class="response-note " v-else-if="question.pivot.userInteracted && !question.answers[1].desired && question.pivot.answer && question.answers[1].text == question.pivot.answer.text
        "> {{ $t('signInOut.responseDoesNotMeetPolicyUpdateJustificationNotes') }}
      </span>

        <!-- <div v-else>
          <span class="response-note vp-mb-24" v-if="!question.answers[1].desired && question.pivot.answer && question.answers[1].text == question.pivot.answer.text
            "> {{ $t('signInOut.responseDoesNotMeetPolicyUpdateJustificationNotes') }}

          </span>
        </div> -->
      </v-radio-group>
    </div>
      <hr class="aggreement-divider" />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  props: ["element", "index", "isNoteChanged"],
  data() {
    return {
      compliance: null,
      answer: {},
      readMore: {},
      fileName: "",
    };
  },
  methods: {
    openPDF(link) {
      console.log("openPDF", link);
      window.open(link, "_blank");
    },
    showPdfFilePreview(url) {
      window.open(url, '_blank');
    },
    getPDFName(link) {
      const fileNameWithExt = link.substring(link.lastIndexOf("/") + 1);
      const fileName = fileNameWithExt.replace(".pdf", "");
      return fileName;
    },
    getDate(date) {
      return moment
        .utc(date)
        .tz(moment.tz.guess()).locale(this.getLanguage)
        .format("DD/MM/YYYY - h:mm A");
    },
    getAdminOrUserStr(str){
      if(str == 'Admin'){
        return (this.$t('common.admin')).toLowerCase();
      }else if(str == 'User'){
        return  (this.$t('common.user')).toLowerCase();
      }
    },
    updatePivot(questionObj, userAnswer) {
      // Mark as user interacted when user changes the answer
      if (!questionObj.pivot.userInteracted) this.$set(questionObj.pivot, 'userInteracted', true);
      let optinalNoteAnswer = true;
      if(!questionObj.pivot.answer.desired) optinalNoteAnswer = false;
      const answerObject = questionObj.answers.find(
        (answer) => answer.text == userAnswer
      );
      Object.assign(questionObj.pivot, {
        answer: {
          text: userAnswer,
          optinalNoteAnswer,
          ...answerObject,
          complianceIndex: this.index,
        },
      });
      this.$emit("updateCompliance", this.compliance);
    },
    showMore(id) {
      this.$set(this.readMore, id, true);
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
  },
  watch: {
    isNoteChanged(value) {
      // If isNoteChanged is an array and the value at this compliance's index is true, set userInteracted for all questions
      if (Array.isArray(value) && typeof this.index === 'number' && value[this.index]) {
        if (this.compliance && Array.isArray(this.compliance.answer)) {
          this.compliance.answer.forEach(q => {
            if (q.pivot) q.pivot.userInteracted = true;
          });
        }
      }
    },
  },
  computed: {
    ...mapGetters("i18N", ["getLanguage"]),
  },
  beforeMount() {
    // Ensure userInteracted is initialized for each question
    if (this.element && Array.isArray(this.element.answer)) {
      this.compliance = {
        ...this.element,
        answer: this.element.answer.map(q => ({
          ...q,
          pivot: q.pivot ? { ...q.pivot, answer: { ...(q.pivot.answer || {}) }, userInteracted: false } : { userInteracted: false },
        })),
      };
    } else {
      this.compliance = this.element;
    }
    console.log("ComplianceForm beforeMount", this.compliance);
  },
  destroyed() {
    this.compliance = [];
  },
};
</script>
<style lang="scss" scoped>
.user-infocontainer {
  background: #F2F2F2;
  text-align: center;
  margin-bottom: 40px;
  p.user-info {
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #4A4A4A !important;
    padding: 5px;
    margin: auto !important;
  }
  .user-strong-txt{
    font-weight: 700 !important;
    font-size: 14px !important;
    line-height: 17px !important;
  }
}
.compliance-text-header {
  font-weight: 700;
  font-size: 16px;
  line-height: 19.2px;
  color: #4A4A4A;
  margin-bottom: 30px;
}
.read_more {
  width: 69px;
  height: 17px;
  inset-inline-start: 721px;
  top: 503px;

  font-weight: 700;
  font-size: 14px;
  line-height: 23.5px;
  text-decoration-line: underline !important;
  color: #2680eb;
}
#complienceForm {
  .info {
    font-weight: 400 !important;
    font-size: 16px;
    line-height: 24px;
    color: #4A4A4A !important;
  }

  .info-success-fail-text{
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    color : #4A4A4A !important;
  }

  .bv-no-focus-ring {
    margin-bottom: 30px;
  }
  .second-info {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 32px;
    letter-spacing: 0.25px;
    color: #4A4A4A;
    word-break: break-all;
  }

  .response-note {
    width: 416px;
    font-family: Lato;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0%;
    color: #F46A6A;
    margin-top: -8px !important;
    display: inline-flex;
  }

  .response-note-admin {
    width: 416px;
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0%;
    color: #787878;
    margin-top: -8px !important;
    display: inline-flex;
  }

  .custom-control{
    padding-left: 0px !important;
  }

  .aggreement-divider{
    margin-bottom: 24px !important;
    margin-top: 24px !important;
  }

  .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: auto;
    max-height: calc(100vh - 300px);
    margin: 0 auto;
    width: 100%;
    overflow: hidden;
    margin-bottom: 32px;
    background: #fff;
    
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      cursor: zoom-in;
    }
  }



}
</style>

<style lang="scss">
.question-wrapper {
  .v-input--radio-group__input {
    flex-direction: column !important;
  }
}

.facemask-questioncon {
  width: 416px;
  margin: auto;
  .response-err {
    font-size: 14px;
    font-weight: 400;
    margin-top: -8px;
    color: #787878;
    text-align: start;
  }
  .response-err-danger {
    color: #f46a6a !important;
  }
  p.facemask {
    font-weight: 400;
    font-size: 16px;
    word-break: break-word !important;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #4A4A4A;
    margin-bottom: 32px;
  }

}
.radios-container {
  .v-input--radio-group__input {
    display: grid;
    gap: 24px;
  }
  .v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
    margin-bottom: 0;
  }
  .text-danger label,
  .text-danger span {
    color: #f46a6a !important;
  }
  .text-success label,
  .text-success span {
    color: #34c38f !important;
  }
  .text-success,
  .text-danger {
    pointer-events: none;
  }
}
</style>
